module.exports = __webpack_public_path__ + "img/error.eb0918a6.svg";